module.exports = __webpack_public_path__ + "img/pos.1985b968.png";